'use strict';

const Paciente = require('./paciente');

module.exports = { Paciente };
